import React, {useEffect, useMemo, useState} from 'react';
import TopTitleBlock from '../../../Components/TopTitleBlock/TopTitleBlock';
import s from './CashOrdersList.module.css';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import style from '../../PaperworkList/PaperworkList.module.css';
import VeryLightGreenButton from '../../../Components/Buttons/VeryLightGreenButton';
import AddFilterButton from '../../../Components/Buttons/AddFilterButton';
import CashOrdersFilter from '../../../Components/Filter/CashOrdersFilter';
import styleTableGrid from '../../ListOfProducts/ListOfProductsTableGrid/ListOfProductsTableGrid.module.css';
import LightGreenButton from '../../../Components/Buttons/LightGreenButton';
import TableTotalBlock from '../../../Components/TableCommonDirectory/TableElements/TableTotalBlock';
import CashOrderTableElement from './components/CashOrderTableElement';
import {useTranslation} from 'react-i18next';
import CashierTableHead from './components/CashierTableHead';
import {useGetBillingListQuery} from '../../../redux/DepotSlice/depotCashierApi';
import {
	CashierOrderType,
	RequestBillingListType,
} from '../../../types/CashierSliceStateType';
import PreLoaderComponent from '../../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import {dateFormatter} from '../../../assets/utils/dateUtils';
import {useStatusRestriction} from '../../../hooks/useStatusRestriction';
import StatusRestrictionMessage from '../../../Components/StatusRestrictionMessage/StatusRestrictionMessage';

const CashOrdersList = () => {
	const currentDate = new Date();
	const {t} = useTranslation();
	const location = useLocation();
	const navigate = useNavigate();
	const restrictions = useStatusRestriction();

	const [showAll, setShowAll] = useState(false);
	const [filterMenu, setFilterMenu] = useState(false);

	// Створюємо дати для поточного та минулого місяця
	const firstDayOfPreviousMonth = new Date(
		currentDate.getFullYear(),
		currentDate.getMonth() - 1,
		1,
	);

	const defaultFilterValues = {
		from_date: dateFormatter(firstDayOfPreviousMonth),
		to_date: dateFormatter(currentDate),
	};
	const [filters, setFilters] =
		useState<RequestBillingListType>(defaultFilterValues);

	const handleClickMoreButton = () => {
		setShowAll(true);
	};
	const {data: billingList, isLoading} = useGetBillingListQuery(filters, {
		skip: !restrictions.canAccessCashOrders,
	});

	const forRenderList = useMemo(() => {
		return showAll ? billingList?.orders : billingList?.orders?.slice(0, 10);
	}, [billingList, showAll]);

	useEffect(() => {
		if (location.state?.defaultFilters) {
			setFilters({
				...defaultFilterValues,
				...location.state.defaultFilters,
			});
			// чистим state після першого рендера
			setTimeout(() => {
				navigate(location.pathname, {replace: true});
			}, 0);
		} else {
			setFilters(defaultFilterValues);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!restrictions.canAccessCashOrders) {
		return (
			<div className="page__content">
				<StatusRestrictionMessage message={t('Сторінка недоступна')} />
			</div>
		);
	}

	return (
		<div className="page__content">
			<TopTitleBlock title={'Список касових ордерів'} />
			<div className={s.buttonContainer}>
				<div className={style.typeInvoiceSelectRight}>
					<Link to={'/creation_of_design'}>
						<VeryLightGreenButton
							type={'button'}
							text={t('створити оформлення')}
						/>
						{/*<ButtonPlusElement />*/}
					</Link>
					<Link to={'/create_cash_order'}>
						<LightGreenButton
							text={t('створити касовий ордер')}
							type={'button'}
						/>
					</Link>
				</div>
			</div>

			<div className={s.filterButton}>
				<AddFilterButton
					setFilterMenu={setFilterMenu}
					filterMenu={filterMenu}
					color={'blue'}
				/>
				{filterMenu && (
					<CashOrdersFilter active={filterMenu} setFilters={setFilters} />
				)}
			</div>
		{/* Обгортка для адаптивного горизонтального скролу */}
		<div className={s.tableWrapper}>
			<div className={styleTableGrid.tableGrid}>
				<CashierTableHead
					titles={['№', 'дата', 'сума', 'статус', 'коментар', 'дії']}
				/>
				{isLoading ? (
					<PreLoaderComponent type={'category'} size={'big'} />
				) : (
					forRenderList?.map((order: CashierOrderType) => (
						<CashOrderTableElement order={order} key={order.id} />
					))
				)}
				{billingList && billingList.orders.length > 10 && !showAll && (
					<div className={s.buttonWrapper}>
						<LightGreenButton
							type={'button'}
							text={t('дивитися більше')}
							onClick={handleClickMoreButton}
						/>
					</div>
				)}
			</div>
		</div>
			<div className={s.totalWrapper}>
				<TableTotalBlock
					info={[
						{
							title: t('Кількість ордерів'),
							data: billingList?.count,
						},
						{
							title: t('Всього грошей'),
							data: billingList?.sum_money,
							currency: ' ГРН',
						},
					]}
				/>
			</div>
		</div>
	);
};

export default CashOrdersList;
